import axiosInstance from '../axios_instance';
import { deviceDetect } from 'react-device-detect';

/*
The store is injected rather than imported, matching setupAxiosInterceptors.
Importing it here created a cycle - UtilizationTracking -> store -> _redux
-> authentication_slice -> UtilizationTracking - which the slices worked around
with dynamic imports, and which made Rollup warn about a module that is both
statically and dynamically imported.
*/
interface MinimalStore { getState: () => any }

let injectedStore: MinimalStore | null = null;

export const setupUtilizationTracking = (store: MinimalStore): void => {
  injectedStore = store;
};

export const logEvent = (
  event: string,
  context: unknown = null,
  seconds_watched: number | null = null,
  credentials: { accessToken: string; client: string; email: string } | null = null,
  video_collection?: string
): Promise<any> => {
  const device = deviceDetect(navigator.userAgent);
  // Falls back to empty credentials if a call somehow lands before setup runs,
  // so tracking can never be the thing that breaks a page.
  const authentication = injectedStore?.getState()?.authentication ?? {};
  const { accessToken, client, email } = credentials || {
    accessToken: authentication.accessToken,
    client: authentication.client,
    email: authentication.email,
  };
  const config = {
    headers: { uid: email, 'access-token': accessToken, client },
  };
  return axiosInstance
    .post(
      `${process.env.REACT_APP_API_URL}/api/log_frontend_utilization`,
      { event, context, seconds_watched, current_path: window.location.pathname + window.location.search, device, session_id: accessToken, ...(video_collection && { video_collection }) },
      config
    )
    .then((response) => response.data)
    .catch((error: any) => {
      console.error('ERROR LOGGING FRONTEND UTILIZATION', error.response);
      if (error.response?.data?.errors && Array.isArray(error.response.data.errors) &&
        (error.response.data.errors.includes('Authorized users only.') ||
          error.response.data.errors.includes('You need to sign in or sign up before continuing.'))) {
        localStorage.clear();
      } else if (error.response) {
        console.log(error.response);
      } else if (error.request) {
        console.log(error.request, error.message);
      } else {
        console.log(error.message);
      }
    });
};

export const logAchievement = (name: string, icon: string | null = null): void => {
  axiosInstance
    .post('/api/achievements', { name, icon, awarded_at: new Date() })
    .catch((error: any) => {
      console.error('ERROR LOGGING ACHIEVEMENT', error.response);
      if (error.response) console.log(error.response);
      else if (error.request) console.log(error.request, error.message);
      else console.log(error.message);
    });
};
